import { useContextSelector } from 'use-context-selector';
import { Card } from '../../domain/Card/entities/Card';
import { CardAction } from '../CardActions';
import { CardDetailsContext } from './CardDetailsContext';

const useCardDetailsErrorState = (errorProperty: 'cardTransactionsDataError' | 'cardDetailsDataError') => {
  const context = useContextSelector(CardDetailsContext, state => state.errorState);

  if (context === undefined) {
    throw new Error('useCardsErrorState must be used within CardDetailsProvider');
  }

  return context[errorProperty];
};

const useCardDetailsLoadingState = (loadingProperty: 'isLoadingCardTransactionsData' | 'isLoadingCardDetailsData') => {
  const context = useContextSelector(CardDetailsContext, state => state.loadingState);

  if (context === undefined) {
    throw new Error('useCardsLoadingState must be used within CardDetailsProvider');
  }

  return context[loadingProperty];
};

const useCardDetails = () => {
  const context = useContextSelector(CardDetailsContext, state => state.cardDetailsData ?? null);

  return context;
};

const useSelectedCardAction = () => useContextSelector(CardDetailsContext, state => state.selectedCardAction ?? null);

const useIsLoadingCardAction = () => {
  const context = useContextSelector(CardDetailsContext, state => state.selectedCardAction?.action ?? null);

  if (context === undefined) {
    throw new Error('useNumberOfCards must be used within CardsProvider');
  }

  return context !== CardAction.viewDetails;
};

const useSelectedCard = () => {
  const context = useContextSelector(CardDetailsContext, state => state.selectedCard?.card as Card);

  // if (context === undefined) {
  //   throw new Error('useSelectedCard must be used within CardsProvider');
  // }

  return context;
};

const useOnSetSelectedCard = () => {
  const context = useContextSelector(CardDetailsContext, state => state.onSetSelectedCard);

  if (context === undefined) {
    throw new Error('useOnSetSelectedCard must be used within CardsProvider');
  }

  return context;
};

const useSelectedCardTransaction = () => {
  const context = useContextSelector(CardDetailsContext, state => state.selectedCardTransaction);

  if (context === undefined) {
    throw new Error('useSelectedCardTransaction must be used within CardDetailsProvider');
  }

  return context;
};

const useCardTransactionDetails = () => {
  const context = useContextSelector(CardDetailsContext, state => state.cardTransactionDetailsData);

  // if (context === undefined) {
  //   throw new Error('useCardTransactionDetails must be used within CardDetailsProvider');
  // }

  return context;
};

const useCardTransactions = () => useContextSelector(CardDetailsContext, state => state.cardTransactionsData ?? []);

const useCardTransactionsFilters = () => {
  const context = useContextSelector(CardDetailsContext, state => state.cardTransactionsFilters);

  if (context === undefined) {
    throw new Error('useCardTransactionsFilters must be used within CardDetailsProvider');
  }

  return context;
};

const useOnCardTransactionListFiltersChange = () => {
  const context = useContextSelector(CardDetailsContext, state => state.onCardTransactionListFiltersChange);

  if (context === undefined) {
    throw new Error('useOnCardTransactionListFiltersChange must be used within CardDetailsProvider');
  }

  return context;
};

const useOnCardTransactionSelect = () => {
  const context = useContextSelector(CardDetailsContext, state => state.onCardTransactionSelect);

  if (context === undefined) {
    throw new Error('useOnCardTransactionSelect must be used within CardDetailsProvider');
  }

  return context;
};

const useCardTransactionsPagination = () => {
  const context = useContextSelector(CardDetailsContext, state => state.cardTransactionsPagination);

  if (context === undefined) {
    throw new Error('useCardTransactionsPagination must be used within CardDetailsProvider');
  }

  return context;
};

const useRefetchCardDetailsMutation = () => {
  const context = useContextSelector(CardDetailsContext, state => state.refetchCardsDetailsDataMutation);

  if (context === undefined) {
    throw new Error('useRefetchCardDetailsMutation must be used within CardDetailsProvider');
  }

  return context;
};

const useRefetchCardsTransactionsMutation = () => {
  const context = useContextSelector(CardDetailsContext, state => state.refetchCardsTransactionsDataMutation);

  if (context === undefined) {
    throw new Error('useRefetchCardsTransactionsMutation must be used within CardDetailsProvider');
  }

  return context;
};

export {
  useCardDetailsErrorState,
  useCardDetailsLoadingState,
  useSelectedCardTransaction,
  useCardTransactions,
  useOnCardTransactionSelect,
  useCardTransactionDetails,
  useOnCardTransactionListFiltersChange,
  useCardDetails,
  useCardTransactionsFilters,
  useCardTransactionsPagination,
  useRefetchCardDetailsMutation,
  useRefetchCardsTransactionsMutation,
  useSelectedCardAction,
  useIsLoadingCardAction,
  useSelectedCard,
  useOnSetSelectedCard,
};
